import 'normalize.css'
import '@revolut-internal/ui-kit/styles.css'

import { PropsWithChildren } from 'react'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { BrowserRouter } from 'react-router-dom'

import { EnvPermissionsProvider } from '@revolut-internal/idave-web-auth'

import { AppPermissionsMap, permissions } from 'common/auth/auth'
import { ToastsProvider } from 'common/toasts/ToastsProvider'
import { TableRowHeightProvider } from 'modules/Monitoring/providers/TableRowHeightProvider'

import { AppRoutes } from './AppRoutes'
import { ReactQueryProvider } from './ReactQueryProvider'
import { RootProvider } from './RootProvider'
import { TopLevelErrorBoundary } from './TopLevelErrorBoundary'

const AppProviders = ({ children }: PropsWithChildren) => {
  return (
    <TopLevelErrorBoundary>
      <RootProvider>
        <ToastsProvider>
          <EnvPermissionsProvider<AppPermissionsMap> permissionsService={permissions}>
            <TableRowHeightProvider>
              <ReactQueryProvider>
                <BrowserRouter>{children}</BrowserRouter>
                <ReactQueryDevtools />
              </ReactQueryProvider>
            </TableRowHeightProvider>
          </EnvPermissionsProvider>
        </ToastsProvider>
      </RootProvider>
    </TopLevelErrorBoundary>
  )
}

export const App = () => {
  return (
    <AppProviders>
      <AppRoutes />
    </AppProviders>
  )
}
